export interface GetShowroomShortlistCommand {
  variantSkuIds: number[];
}

export class ShowroomShortlistCommands {
  static getGetShowroomShortlistCommand(variantSkuIds: number[]): GetShowroomShortlistCommand {
    return {
      variantSkuIds: variantSkuIds,
    };
  }
}
